var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{attrs:{"now":_vm.currentProgram}}),_c('BottomPlayer',{ref:"player",staticClass:"bottom-player",attrs:{"id":"bottom-player","now":_vm.currentProgram}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }